// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"5cad7d9b","5378":"edb30248","7732":"5cad7d9b"}[chunkId] + ".chunk.css";
};